// extracted by mini-css-extract-plugin
export default {"hideTooltip":"Q_-z","fadeIn":"R_-z","delay":"S_-z","recommendedSizeTooltip":"T_-z"};